// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Title } from '@mantine/core';
import { SignInForm } from '@medplum/react';
import type { JSX } from 'react';
import { useNavigate } from 'react-router';
import polarisLogo from '../assets/polaris-logo.svg';
import { PROVIDER_AUTH_SCOPE } from '../auth-config';
import classes from './SignInPage.module.css';

export function SignInPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className={classes['sign-in']}>
      <SignInForm
        // Configure according to your settings
        projectId={import.meta.env.VITE_MEDPLUM_PROJECT_ID}
        scope={PROVIDER_AUTH_SCOPE}
        googleClientId="921088377005-3j1sa10vr6hj86jgmdfh2l53v3mp7lfi.apps.googleusercontent.com"
        onSuccess={() => navigate('/')?.catch(console.error)}
        onForgotPassword={() => navigate('/forgot-password')?.catch(console.error)}
      >
        <img src={polarisLogo} alt="Polaris Sleep" width={147} height={28} />
        <Title order={3} py="lg">
          Sign in to Provider
        </Title>
      </SignInForm>
    </div>
  );
}
